// Static summary block popup handler
    $(document).on('click', '[data-free-gift-modal-trigger="true"]', function() {
       var $info = $(this);
       var title = $info.data('free-title') || $info.find('.free-product-info-title').text() || '';
       var productimg = $info.data('free-img') || $info.find('img').attr('src') || '';
       var productDesc = $info.data('free-desc') || '';
       var variantSummary = $.trim($('.free-product-variant').text() || '');
       var priceSummary = $.trim($('.free-product-price').text() || '');
       var variantPriceText = variantSummary;
       if (priceSummary) {
         variantPriceText = variantPriceText ? (variantPriceText + ' - ' + priceSummary) : priceSummary;
       }

       $('#product .container-popup-item-second').hide();
       $('body').css('overflow','hidden');
       if (productimg) {
         $('#product .container-popup-item-first img').attr('src', productimg);
       }
       $('#product .container-popup-item-first .right-col .modal-head').html(title);
       $('#product .product-desc').text(productDesc);
       $('#product .container-popup-item-first .right-col .variant-price').html(variantPriceText);
       $('#product .modal-content h3').html(title);
       $('#product .modal-content .modal-description').text(productDesc);
       // Show combined variant + price summary from the free-product info block
       $('#product .modal-content .submodal-description').text(variantPriceText);
       $('#product .modal-product-list').html('');
       $('#product .modal-product-sale-message').html('');
       $("#product .order").hide();
       $("#product .close-modal-cta").show();
       $('#product .close-modal-cta a').text('CLOSE');
       $('#product .close-modal-cta a').removeAttr('data-value');
       $('#product .modal').show();
       return false;
    });

    /**
     * Automatically selects the matching free gift variant based on the main product variant
     * for each free gift product block (supports multiple free gifts from metafield list).
     * Matches by size (first part of main variant title before '/').
     */
function switchFreeGiftVariant(selectedMainVariantTitle) {
  if (!selectedMainVariantTitle) return;
  var selectedTitle = selectedMainVariantTitle.split('/')[0].trim().toLowerCase();
  selectedTitle = selectedTitle.replace(/\(.*?\)/, '').trim();

  // Map mattress sizes to pillow tier for products that only have Queen/King variants
  var queenSizes = ['twin', 'twin xl', 'full', 'queen', 'split king (order 2 to make a set)'];
  var pillowSize = queenSizes.indexOf(selectedTitle) > -1 ? 'queen' : 'king';

  $('.free-gift-product-block').each(function() {
    var $block = $(this);
    var $freeGiftVariants = $block.find('.free-gift-variants-data span');
    if ($freeGiftVariants.length === 0) return;

    // 1. Exact match on size
    var matchedVariant = $freeGiftVariants.filter(function() {
      var variantTitle = ($(this).data('variant-title') || '').trim().toLowerCase();
      return variantTitle === selectedTitle;
    }).first();

    // 2. Word-boundary match (e.g. "queen" in "queen (2-pack)")
    if (!matchedVariant.length) {
      var boundaryRegex = new RegExp('\\b' + selectedTitle.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b', 'i');
      matchedVariant = $freeGiftVariants.filter(function() {
        var variantTitle = ($(this).data('variant-title') || '').trim().toLowerCase();
        return boundaryRegex.test(variantTitle);
      }).first();
    }

    // 3. Pillow-tier fallback (queen/king mapping)
    if (!matchedVariant.length) {
      var pillowRegex = new RegExp('\\b' + pillowSize + '\\b', 'i');
      matchedVariant = $freeGiftVariants.filter(function() {
        var variantTitle = ($(this).data('variant-title') || '').trim().toLowerCase();
        return pillowRegex.test(variantTitle);
      }).first();
    }

    // 4. First available variant as last resort
    if (!matchedVariant.length) {
      matchedVariant = $freeGiftVariants.filter(function() {
        var available = $(this).data('variant-available');
        return available === true || available === 'true';
      }).first();
    }
    if (matchedVariant.length) {
      var variantId = matchedVariant.data('variant-id');
      var variantTitle = matchedVariant.data('variant-title');
      var variantPrice = matchedVariant.data('variant-price');
      $block.find('.free-gift-variant-title').text(variantTitle);
      $block.find('.free-gift-variant-price').text(variantPrice);
      $block.find('input.free-gift-radio-input').val(variantId);
    }
  });

  if (typeof updateFreeProductSummary === 'function') {
    updateFreeProductSummary();
  }
}

function updateFreeProductSummary() {
  var $info = $('.free-product-info');
  if (!$info.length) return;

  var $variantSpan = $info.find('.free-product-variant');
  var $priceSpan = $info.find('.free-product-price');

  // Get the selected mattress size from the main dropdown
  var selectedText = ($('#dropdownMattressSize option:selected').data('title') || '').trim();
  var mattressSize = selectedText.split('/')[0].trim().replace(/\(.*?\)/, '').trim();

  if (!mattressSize) {
    $variantSpan.text('');
    $priceSpan.text('');
    return;
  }

  // Sum compare_at_price from each hidden gift block (already set by switchFreeGiftVariant)
  var total = 0;
  var currencyPrefix = '';

  $('.free-gift-product-block').not('.free-product-summary-block').each(function() {
    var priceText = ($(this).find('.free-gift-variant-price').first().text() || '').trim();
    if (!priceText) return;

    if (!currencyPrefix) {
      var prefixMatch = priceText.match(/^[^0-9]*/);
      if (prefixMatch) currencyPrefix = prefixMatch[0];
    }

    var numeric = parseFloat(priceText.replace(/[^0-9.]/g, ''));
    if (!isNaN(numeric)) {
      total += numeric;
    }
  });

  $variantSpan.text(mattressSize);
  if (total > 0) {
    $priceSpan.text((currencyPrefix || '') + total);
  } else {
    $priceSpan.text('');
  }
}

// Run summary on initial load and whenever a free-gift variant is changed manually
$(function() {
  if (typeof updateFreeProductSummary === 'function') {
    updateFreeProductSummary();
  }

  $(document).on('change', '.free-gift-radio-input', function() {
    if (typeof updateFreeProductSummary === 'function') {
      updateFreeProductSummary();
    }
  });
});